import * as api from '../../../requests'
import {
  SET_SEARCH_RESULTS,
  SET_AMENDMENT_WIZARDS,
  SET_LOADING_AMENDMENT_WIZARDS,
  SET_PAPER_FILING_ERROR_MESSAGE,
  SET_WORKVIEW_2_CATEGORY_USERS,
  SET_LIEN_FORMS,
  SET_TRADEMARK_FORMS,
  SET_BUSINESS_FORMS,
  SET_NOTARY_FORMS, SET_REGISTERED_AGENT_FORMS, SET_ATHLETE_AGENT_FORMS, SET_ORDER_FORMS
} from '../../WVManager/Workview2Reducer'
import { FilingSourceTypeIds} from '../../../Utilities/Utilities'

const FilterErrorMessage = (error, dispatch) => {
  console.error(error)
  const errorObj = JSON.parse(error)
  dispatch({
    type: SET_PAPER_FILING_ERROR_MESSAGE,
    paperFilingErrorMessage: errorObj.detail,
  })
}

export const getAmendmentFilingWizards = (FilingNum) => (dispatch, getState) => {
  dispatch({ type: SET_AMENDMENT_WIZARDS, amendmentWizards: [] })
  dispatch({ type: SET_LOADING_AMENDMENT_WIZARDS, loadingAmendmentWizards: true })
  const sourceTypeId = getState().workview.selectedRow.SourceTypeId
  switch (sourceTypeId) {
    case FilingSourceTypeIds.Lien:
      api.GET_UCC_WIZARDS(
        FilingNum,
        (data) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: data,
            loadingAmendmentWizards: false,
          })
        },
        (error) => {
          dispatch({
            type: SET_LOADING_AMENDMENT_WIZARDS,
            amendmentWizards: [],
            loadingAmendmentWizards: false,
          })
          FilterErrorMessage(error, dispatch)
        }
      )
      break
    case FilingSourceTypeIds.Trademark:
      api.GET_TRADEMARK_WIZARDS(
        FilingNum,
        (data) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: data,
            loadingAmendmentWizards: false,
          })
        },
        (error) => {
          dispatch({
            type: SET_LOADING_AMENDMENT_WIZARDS,
            amendmentWizards: [],
            loadingAmendmentWizards: false,
          })
          FilterErrorMessage(error, dispatch)
        }
      )
      break
    case FilingSourceTypeIds.Orders:
      api.GET_BUSINESS_CERTIFICATION_WIZARDS(
        (data) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: data,
            loadingAmendmentWizards: false,
          })
        },
        (error) => {
          dispatch({
            type: SET_LOADING_AMENDMENT_WIZARDS,
            amendmentWizards: [],
            loadingAmendmentWizards: false,
          })
          FilterErrorMessage(error, dispatch)
        }
      )
      break
    case FilingSourceTypeIds.Notary:
      api.GET_NOTARY_WIZARDS(
        FilingNum,
        (data) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: data,
            loadingAmendmentWizards: false,
          })
        },
        (error) => {
          dispatch({
            type: SET_LOADING_AMENDMENT_WIZARDS,
            amendmentWizards: [],
            loadingAmendmentWizards: false,
          })
          FilterErrorMessage(error, dispatch)
        }
      )
      break
    case FilingSourceTypeIds.RegisteredAgent:
      api.GET_REGISTERED_AGENT_WIZARDS(
        FilingNum,
        (data) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: data,
            loadingAmendmentWizards: false,
          })
        },
        (error) => {
          dispatch({ type: SET_LOADING_AMENDMENT_WIZARDS, loadingAmendmentWizards: false })
          FilterErrorMessage(error, dispatch)
        }
      )
      break
    case FilingSourceTypeIds.AthleteAgent:
      api.GET_ATHLETE_AGENT_AMENDMENT_WIZARDS(
        FilingNum,
        (data) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: data,
            loadingAmendmentWizards: false,
          })
        },
        (error) => {
          dispatch({ type: SET_LOADING_AMENDMENT_WIZARDS, loadingAmendmentWizards: false })
          FilterErrorMessage(error, dispatch)
        }
      )
      break
    // Add cases for new modules here instead of creating separate request methods for each module.
    case FilingSourceTypeIds.Charity:
    case FilingSourceTypeIds.Lobbyist:
    case FilingSourceTypeIds.Contractor:
      api.GET_AMENDMENT_WIZARDS(
        sourceTypeId,
        FilingNum,
        (data) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: data,
            loadingAmendmentWizards: false,
          })
        },
        (error) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: [],
            loadingAmendmentWizards: false,
          })
          FilterErrorMessage(error, dispatch)
        }
      )
      break
    default:
      api.GET_BUSINESS_AMENDMENT_WIZARDS(
        // business
        FilingNum,
        (data) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: data,
            loadingAmendmentWizards: false,
          })
        },
        (error) => {
          dispatch({
            type: SET_AMENDMENT_WIZARDS,
            amendmentWizards: [],
            loadingAmendmentWizards: false,
          })
          FilterErrorMessage(error, dispatch)
        }
      )
      break
  }
}

export const searchEntities = (query) => {
  return (dispatch) => {
    api.PAPER_MODAL_ENTITY_SEARCH(
      query.SearchName, 
      query.RecordNum, 
      query.QueryTypeId, 
      query.SourceTypeId,
      (results) => 
        dispatch({
          type: SET_SEARCH_RESULTS,
          results
        }),
      (error) => console.error(error)
    )
  }
}

export const searchBusinessEntities = (query) => {
  return (dispatch) => {
    api.BO_SEARCH(
      { ...query },
      'BusinessEntitySearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const searchRegisteredAgents = (query) => {
  return (dispatch) => {
    api.BO_SEARCH(
      { ...query },
      'RegisteredAgentEntitySearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const searchTrademarkEntities = (query) => {
  return (dispatch) => {
    api.BO_SEARCH(
      query,
      'TrademarkEntitySearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const searchUCCEntities = (query) => {
  query.QueryID = 2006
  return (dispatch) => {
    api.BO_SEARCH(
      query,
      'UCCEntitySearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const searchNotary = (query) => {
  return (dispatch) => {
    api.BO_SEARCH(
      query,
      'NotaryEntitySearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const searchAthleteAgent = (query) => {
  return (dispatch) => {
    api.BO_SEARCH(
      {
        ...query,
        SearchFullName: query.SearchName,
        LicenseNum: query.FileNumber,
      },
      'AthleteAgentSearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const searchCharity = (query) => {
  return (dispatch) => {
    api.BO_SEARCH(
      {
        ...query,
        SearchName: query.SearchName,
        RecordNumber: query.FileNumber,
      },
      'CharitableOrganizationSearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const searchContractor = (query) => {
  return (dispatch) => {
    api.BO_SEARCH( 
      {
        ...query,
        ContractorName: query.SearchName,
        RecordNum: query.FileNumber,
      },
      'ContractorSearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const searchLobbyist = (query) => {
  return (dispatch) => {
    api.BO_SEARCH( 
      {
        ...query,
        LobbyistName: query.SearchName,
        RecordNum: query.FileNumber,
      },
      'LobbyistSearch',
      (results) =>
        dispatch({
          type: SET_SEARCH_RESULTS,
          results,
        }),
      (error) => console.error(error)
    )
  }
}

export const getFilingWizards = (sourceType) => (dispatch, getState) => {
  const activeSourceTypes = getState().app.activeSourceTypes
  api.GET_WORKVIEW_USERS_LIST(
    (data) => {
      dispatch({ type: SET_WORKVIEW_2_CATEGORY_USERS, workviewCategoryUsers: data })
    },
    (err) => console.error(err)
  )
  // console.log(activeSourceTypes)
  if (sourceType === 2000  &&activeSourceTypes.find((type) => type.ModuleName === 'UCC' && type.IsActive)) {
    api.GET_FORMS(
      'UCC',
      (data) => {
        dispatch({
          type: SET_AMENDMENT_WIZARDS,
          amendmentWizards: data,
          loadingAmendmentWizards: false,
        })      },
      (err) => {
        dispatch({ type: SET_LIEN_FORMS, options: [] })
        console.error(err)
      }
    )
  }
  if (sourceType === 811 && activeSourceTypes.find((type) => type.ModuleName === 'Trademark' && type.IsActive)) {
    api.GET_FORMS(
      'trademark',
      (data) => {
        // console.log('tm', data)
        dispatch({
          type: SET_AMENDMENT_WIZARDS,
          amendmentWizards: data,
          loadingAmendmentWizards: false,
        })
      },
      (err) => {
        dispatch({ type: SET_TRADEMARK_FORMS, options: [] })
        console.error(err)
      }
    )
  }
  if (sourceType === 169 && activeSourceTypes.find((type) => type.ModuleName === 'Business' && type.IsActive)) {
    api.GET_FORMS(
      'business',
      (data) => {
        dispatch({
          type: SET_AMENDMENT_WIZARDS,
          amendmentWizards: data,
          loadingAmendmentWizards: false,
        })
      },
      (err) => {
        dispatch({ type: SET_BUSINESS_FORMS, options: [] })
        console.error(err)
      }
    )
  }
  if (sourceType === 851 && activeSourceTypes.find((type) => type.ModuleName === 'Notary' && type.IsActive)) {
    api.GET_FORMS(
      'notary',
      (data) => {
        dispatch({
          type: SET_AMENDMENT_WIZARDS,
          amendmentWizards: data,
          loadingAmendmentWizards: false,
        })
      },
      (err) => {
        dispatch({ type: SET_NOTARY_FORMS, options: [] })
        console.error(err)
      }
    )
  }
  if (sourceType === 462 && activeSourceTypes.find((type) => type.ModuleName === 'RegisteredAgent' && type.IsActive)) {
    api.GET_FORMS(
      'registeredAgent',
      (data) => {
        dispatch({
          type: SET_AMENDMENT_WIZARDS,
          amendmentWizards: data,
          loadingAmendmentWizards: false,
        })
      },
      (err) => {
        dispatch({ type: SET_REGISTERED_AGENT_FORMS, options: [] })
        console.error(err)
      }
    )
  }
  if (sourceType === 1001 && activeSourceTypes.find((type) => type.ModuleName === 'AthleteAgent' && type.IsActive)) {
    api.GET_FORMS(
      'athleteAgent',
      (data) => {
        dispatch({
          type: SET_AMENDMENT_WIZARDS,
          amendmentWizards: data,
          loadingAmendmentWizards: false,
        })
      },
      (err) => {
        dispatch({ type: SET_ATHLETE_AGENT_FORMS, options: [] })
        console.error(err)
      }
    )
  }
  if (sourceType === 167 &&
    activeSourceTypes.find(
      (type) => type.ModuleName === 'Orders' || (type.ModuleName === 'Order' && type.IsActive)
    )
  ) {
    api.GET_FORMS(
      'order',
      (data) => {
        dispatch({
          type: SET_AMENDMENT_WIZARDS,
          amendmentWizards: data,
          loadingAmendmentWizards: false,
        })
      },
      (err) => {
        dispatch({ type: SET_ORDER_FORMS, options: [] })
        console.error(err)
      }
    )
  }
}
